import { useTheme } from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { InformationModalLayout } from 'modules/components/layer13';
import * as ds from './dataService';



export type ResetProjectMilestonesModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ResetProjectMilestonesModalProps) => {
  const theme = useTheme();
  const [
    fnResetMilestones,
    { loading }
  ] = ds.useResetMilestones();
  return (
    <InformationModalLayout.FC
      id={props.id}
      title='Reset Milestones'
      subTitle='This change can not be undone.'
      headerIcon={<CustomIcon.medium.FC icon='FLAGALT' stroke={theme.palette.error.main} />}
      handleClose={props.handleClose}
      loading={loading}
      successButton={{
        handleClick: async () => {
          await fnResetMilestones(props.id);
          props.handleClose();
        },
        text: 'Reset Milestones'
      }}
      isVisible={props.isVisible}
    >

    </InformationModalLayout.FC>
  );
};
